import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../../baseClasses/BaseComponent';
import './LocationAddCard.scss';
import dataModel from '../../../../models/DataModel';
import { location_root } from '../../../../dao/LocationsDAO';
import Input from '../../../../components/Input';

export class LocationAddCard extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = { locationName: '' };
  }

  componentDidMount() {
    super.componentDidMount();
    if (this.inputField) {
      this.inputField.focus();
    }
  }

  handleAddLocation() {
    const locationName = this.state.locationName && this.state.locationName.trim();
    if (this.handleValidation(locationName)) {
      const newLocation = { name: locationName }; 
      
      let self = this;
      dataModel.locationsDAO.createLocation(newLocation, { recordDescriptor: location_root }).then(location => {
        if (self.props.handleLocationAdd) {
          self.props.handleLocationAdd(location);
        }
        self.handleCancel();
      });
    }
    else {
      this.props.dataModel.displayInfoErrorMessage(this.textMap.locationNameRequired, 4000, 2);
    }
  }

  handleCancel() {
    if (this.props.closeAddCard) {
      this.props.closeAddCard();
    }
  }

  handleChange(e) {
    this.setState({ locationName: e.target.value });
  }

  handleKeyDown(e) {
    if (e.keyCode == 13 || e.keyCode == 40) {
      this.handleAddLocation();
    }
    else if (e.keyCode == 27) {
      this.handleCancel();
    }
  }

  handleValidation(string){
    let pass = false;
    if (string && string.length > 0 && string.trim() != ''){
      pass = true;
    }
    return pass;
  }

  render() {
    return (
      <div className={'location-add-card'} id={this.props.id}>
        <div className="add-location-box">
          <Input className="location-input" value={this.state.locationName} onChange={this.handleChange}
            placeholder={this.textMap.newLocation} onKeyDown={this.handleKeyDown} ref={(element) => {
              this.inputField = element;
            }}/>
        </div>
        <div className="add-button"><span className="add-text" onClick={this.handleAddLocation}>{this.textMap.add.toUpperCase()}</span></div>
        <div className="cancel-button" onClick={this.handleCancel}/>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    permissions: state.new_users ? state.new_users.permissions : null,
    currentCompany: state.new_companies.currentCompany,
    currentUser: state.new_users.currentUser,
  };
};

export default connect(mapStateToProps)(LocationAddCard);



// WEBPACK FOOTER //
// ./src/containers/PORContainer/PORNav/LocationAddCard/index.js